import { EcommerceTrackingData } from "./ecommerce-tracking-data.class";
export class UniversityCardImpressionData extends EcommerceTrackingData {
    productId;
    listPageType;
    listName;
    organisationId;
    listPosition;
    constructor(productId, listPageType, listName, organisationId, listPosition) {
        super(productId, listPageType, listName, organisationId, undefined, undefined, listPosition, undefined, undefined);
        this.productId = productId;
        this.listPageType = listPageType;
        this.listName = listName;
        this.organisationId = organisationId;
        this.listPosition = listPosition;
    }
    getTrackingContext() {
        return {
            organisationId: this.getProductId(),
            studyId: undefined,
            scholarshipId: undefined,
            bodyId: undefined,
            premiumnessLevel: this.premium?.toString() ?? '',
            price: undefined,
            position: this.listPosition,
            currency: this.getCurrency()
        };
    }
}
